import { useHashRoute } from "@/hooks/useHashRoute";
import { Login } from "@/routes/Login";
import { VmControl } from "@/routes/VmControl";
import { Admin } from "@/routes/Admin";
import { RequireAuth } from "@/components/RequireAuth";

export default function App() {
  const { path } = useHashRoute();

  if (path === "/login") return <Login />;
  if (path === "/admin") return <Admin />;
  return (
    <RequireAuth>
      <VmControl />
    </RequireAuth>
  );
}
